import React from 'react';

import { FieldTitle } from '../../common';

const LiquidAssets = ({ label, internalTitle, formId, required, placeholder, ...props }) => {
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;

  return (
    <div>
      <div className="hint">freie Liquidität, Tagesgelder, Sparanlagen (Gesamtsumme)</div>

      <input
        type="text"
        name={internalTitle}
        id={forId}
        required={required}
        placeholder={required && !label.length ? `${placeholder} *` : placeholder}
        className={`liquid-assets ${internalTitle}`}
        tabIndex="20"
      />
      <i className="fa fa-times-circle"></i>
    </div>
  );
};

LiquidAssets.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  formId: React.PropTypes.number,
  required: React.PropTypes.bool,
  placeholder: React.PropTypes.string,
  contentArticleFormId: React.PropTypes.number
};

export default LiquidAssets;



// WEBPACK FOOTER //
// ./components/forms/depotCheck/liquidAssets.js